import { render, staticRenderFns } from "./basicSettings.vue?vue&type=template&id=23a00a90&scoped=true&"
import script from "./basicSettings.vue?vue&type=script&lang=js&"
export * from "./basicSettings.vue?vue&type=script&lang=js&"
import style0 from "./basicSettings.vue?vue&type=style&index=0&id=23a00a90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a00a90",
  null
  
)

export default component.exports